<template>
  <div class="item" :class="{ noStart: !activityState }" @click="toActivityPlace">
    <div class="head">
      <div
        class="avatar"
        :style="{
          backgroundImage: 'url(' + data.brandLogo + ')',
        }"
      ></div>
      <div class="title">
        <div class="tit">
          <div class="value">
            <template v-if="data.activityReward === 'COMMISSION' && $store.state.user.distributionFlag">
              <iframe class="img" :src="require('@/assets/goodsdetail/双倍佣金.svg')"></iframe>
            </template>
            <template v-if="data.activityReward === 'AWARD'">
              <iframe class="img" :src="require('@/assets/goodsdetail/抽奖专场.svg')"></iframe>
            </template>
            <template v-if="data.activityReward === 'NEWBIE'">
              <iframe class="img" :src="require('@/assets/goodsdetail/新人专场.svg')"></iframe>
            </template>
            <span class="van-ellipsis">{{ data.brandName }}</span>
          </div>
          <div class="btn" @click.stop="shareClick" v-distributor="true">
            <span>分享赚钱</span>
            <img class="inline" src="@/assets/home/fenxiangzhuanqian.svg" />
          </div>
          <div class="btn" v-distributor="false">
            <span>进入会场</span>
          </div>
        </div>
        <div class="tips clearfix">
          <span class="van-hairline--surround">共{{ data.goodsNum || 0 }}款</span>
          <span class="van-hairline--surround" v-for="item in coupons" :key="data.partId + item.couponId">{{ item.couponName }}</span>
          <span class="van-hairline--surround" v-for="item in data.partServices" :key="item.id">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div
        class="content-item"
        v-for="item in data.brandGoodsList"
        :key="item.goodsId"
      >
        <div
          class="img"
          :style="{
            backgroundImage: 'url(' + item.goodsImage + ')',
          }"
        ></div>
        <div class="amount" v-distributor="true">
          <div class="price">
            <span class="prefix">¥</span>
            <span class="value">{{ item.actPrice }}</span>
          </div>
        </div>
        <div class="amount customer" v-distributor="false">
          <div class="price">
            <span class="prefix">¥</span>
            <span class="value">{{ item.actPrice }}</span>
          </div>
          <div class="unline-price">
            <span class="unline">¥{{ item.linePrice }}</span>
          </div>
        </div>
      </div>
    </div>
    <Countdown :startTime="data.start" :endTime="data.end" @activityStateChange="activityStateChange" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Countdown from "@/components/activity/Countdown";
import { forwardDetail, priceMarkup } from "@/api/forward";
export default {
  components: { Countdown },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    coupons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activityState: true
    }
  },
  computed: {
    ...mapGetters(["distributionFlag"]),
  },
  methods: {
    toActivityPlace() {
      this.$router.push({
        name: "BrandPlace",
        params: { partId: this.data.partId },
        query: {
          actId: this.data.actId,
          brandLogo: this.data.brandLogo,
          signBrandId: this.data.signBrandId,
        },
      });
    },
    async shareClick() {
      if (this.data.state === 'FINISHED') {
        Toast({
          message: '活动已结束',
          position: "center",
          duration: 1000,
        })
        return
      }
      try {
        this.$store.dispatch("app/showLoading");
        const detail = await this.getSharePosterDetail({
          partId: this.data.partId,
          actId: this.data.actId,
          forwardType: "BRAND",
        });
        const forwardUrl =
          `${window.location.origin}/brandPlace/${this.data.partId}?` +
          `actId=${this.data.actId}&brandLogo=${this.data.brandLogo}&signBrandId=${this.data.signBrandId}&` +
          `customerId=${this.$store.state.user.forwardId}`;
        const img = await this.getSharePosterImg({
          actId: this.data.actId,
          forwardType: "BRAND",
          partId: this.data.partId,
          price: detail.price,
          urlAddress: forwardUrl,
        });

        this.sharePosterOpen(img.url, forwardUrl);
        this.$store.dispatch("app/hideLoading");
      } catch (error) {
        this.$store.dispatch("app/hideLoading");
      }
    },
    sharePosterOpen(url, forwardUrl) {
      this.$store.dispatch("sharePoster/show", {
        url,
        title: this.data.brandName,
        desc: this.data.themeName,
        link: forwardUrl,
        imgUrl: this.data.brandLogo,
      });
    },
    // 获取海报数据
    getSharePosterDetail(data) {
      return new Promise((resolve, reject) => {
        forwardDetail(data)
          .then((res) => {
            resolve(res.data);
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 生成海报图片
    getSharePosterImg(data) {
      return new Promise((resolve, reject) => {
        priceMarkup(data)
          .then((res) => {
            resolve(res.data);
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 实时获取开始状态
    activityStateChange(flag) {
      this.activityState = flag
    },
  },
};
</script>

<style lang="less" scoped>
.item {
  background-color: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  text-align: left;
  & + .item {
    margin-top: 24px;
  }
  .head {
    display: flex;
    padding: 32px 32px 20px 24px;
    .avatar {
      width: 88px;
      height: 88px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      border-radius: 12px;
      box-shadow: 0 0 1px #eeeeee;
    }
    .title {
      flex: 1;
      min-width: 0;
      padding-left: 20px;
      .tit {
        display: flex;
        align-items: center;
        .value {
          display: flex;
          align-items: center;
          flex: 1;
          min-width: 0;
          font-weight: bold;
          color: #333333;
          .img {
            display: inline-block;
            height: 30px;
            width: 104px;
            margin-right: 8px;
          }
          span {
            line-height: 24px;
            font-size: 24px;
          }
        }
        .btn {
          display: flex;
          align-items: center;
          background-color: #e82035;
          padding: 8px 12px;
          border-radius: 24px;
          span {
            font-size: 24px;
            line-height: 24px;
            font-weight: 400;
            color: #ffffff;
          }
          img {
            width: 24px;
            margin-left: 8px;
          }
        }
      }
      .tips {
        padding-top: 12px;
        height: 50px;
        overflow: hidden;
        span {
          float: left;
          display: block;
          font-size: 16px;
          line-height: 16px;
          font-weight: 400;
          color: #e82035;
          padding: 9px 10px;
          margin-right: 8px;
          margin-bottom: 100px;
          &::after {
            border-color: #e82035;
            border-radius: 12px;
          }
        }
      }
    }
  }
  .content {
    padding: 0 32px 22px;
    overflow-x: scroll;
    display: flex;
    white-space: nowrap;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
}
.content-item {
  display: inline-block;
  width: 220px;
  & + .content-item {
    margin-left: 20px;
  }
  .img {
    width: 220px;
    height: 220px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 12px;
  }
  .amount {
    padding-top: 20px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    .price {
      display: flex;
      align-items: flex-end;
      color: #333;
      .prefix {
        font-size: 24px;
        line-height: 28px;
        font-weight: 800;
      }
      .value {
        font-size: 32px;
        line-height: 32px;
        font-weight: 800;
      }
    }
    .unline-price {
      display: none;
      align-items: flex-end;
      .unline {
        font-size: 20px;
        color: #808080;
        line-height: 26px;
        text-decoration: line-through;
        margin-left: 8px;
      }
    }
    &.customer {
      justify-content: center;
      .price {
        display: flex;
      }
      .unline-price {
        display: flex;
      }
    }
  }
}

.item.noStart {
  .head .title .tit .btn {
    background-color: #44D7B6;
  }
}
</style>